export const getApiUrl = (version: number) => {
  const {hostname} = window.location;
  let api = version !== 2 ? 'https://api.hypotheker.nl' : 'https://api.hypotheker.nl/v2';

  if (hostname.indexOf('staging') !== -1) {
    api = version !== 2 ? 'https://api.hypotheker.nl' : 'https://staging-api.hypotheker.nl/v2';
  }

  if (hostname.indexOf('test') !== -1) {
    api = version !== 2 ? 'https://testapi.hypotheker.nl' : 'https://test-api.hypotheker.nl/v2';
  }

  if (hostname.indexOf('acc') !== -1) {
    api = version !== 2 ? 'https://acpapi.hypotheker.nl' : 'https://acc-api.hypotheker.nl/v2';
  }

  if (hostname.indexOf('localhost') !== -1) {
    api = version !== 2 ? 'https://api.hypotheker.nl' : 'https://test-api.hypotheker.nl/v2';
  }

  return api;
};

export const getCMSUrl = () => {
  const {hostname} = window.location;
  if (hostname.indexOf('staging') !== -1) return 'https://staging-www.hypotheker.nl/api/v1';
  if (hostname.indexOf('acc') !== -1) return 'https://acc-www.hypotheker.nl/api/v1';
  if (hostname.indexOf('test') !== -1) return 'https://test-www.hypotheker.nl/api/v1';
  if (hostname.indexOf('localhost') !== -1) return 'https://acc-www.hypotheker.nl/api/v1';

  return 'https://www.hypotheker.nl/api/v1';
};
